import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { browserStorage } from 'Redux/services/storage'
import { useFetchArchiveListings } from './archiveListingsApis'
import ArchiveListings from './index'


const bs = browserStorage()

export const perPageCalc = ({
  buildingId, suiteNumber, addressId,
  isArchiveListingsPage, mobileBrowser,
}) => {
  const noPriceHistoryPage = !buildingId && !suiteNumber && !addressId
  const perPage = noPriceHistoryPage ? 4
    : isArchiveListingsPage ? 15
      : mobileBrowser ? 3 : 5

  return perPage
}

const ArchiveListingsApiContainer = ({
  isListing,
  isBuilding,
  isPrint,
  isArchiveListingsPage,
  enableLoadMore,
  showLinkToHistoryPage,
  buildingId,
  addressId,
  suiteNumber,
  propertyClass,
  priceHistoryAtText,
  offer = 'Sale',
  pageFrom,
  enableFilterBar,
  bedTypeNum,
}) => {
  // redux selectors
  const mobileBrowser = useSelector(state => state.app.mobileBrowser)
  const [filteredParams, setParams] = useState({
    suiteNumber,
    offer,
    bedTypeNum,
    offset: 0,
    loadMore: false,
  })
  // const [suiteNumberFiltered, setSuiteNumber] = useState(suiteNumber)
  // const [offerFilter, setOffer] = useState(offer)

  const [archiveListingsData, setArchiveListingsData] = useState({})

  const [isFetchingArchiveListings, setIsFetching] = useState(false)
  const [isFetchingMoreArchiveListings, setIsFetchingMore] = useState(false)

  // const [currentOffset, setCurrentOffset] = useState(0)

  const perPage = perPageCalc({
    buildingId,
    suiteNumber,
    addressId,
    isArchiveListingsPage,
    mobileBrowser,
  })


  const queryComponent = buildingId ? 'building' : 'address'
  // apis

  const loadArchiveListings = ({
    bedTypeNum: bedTypeNumSearch, offset, offer: offerSearch, suiteNumber: unitSearch,
    loadMore,
  }) => {
    const newParams = {}
    if(bedTypeNumSearch) newParams.bedTypeNum = bedTypeNumSearch
    if(unitSearch) newParams.suiteNumber = unitSearch
    if(offerSearch) newParams.offer = offerSearch
    if(offset) newParams.offset = offset
    if(loadMore) newParams.loadMore = loadMore

    // setSuiteNumber(unitSearch)
    // setOffer(offerSearch)
    setParams(newParams)
  }
  const params = {
    buildingId,
    addressId,
    perPage,
    bedTypeCategory: 1,
    ...filteredParams,
  }

  const response = useFetchArchiveListings({
    id: buildingId || addressId,
    component: queryComponent,
    token: bs.token,
    payload: params,
  })
  useEffect(() => {
    if(filteredParams.loadMore) {
      setIsFetchingMore(response.isFetching)
      if(response.data) {
        setArchiveListingsData({
          ...response.data,
          date_groups: [
            ...archiveListingsData.date_groups,
            ...response.data.date_groups,
          ],
        })
        // setCurrentOffset(currentOffset + step)
      }
    } else {
      setIsFetching(response.isFetching)
      setArchiveListingsData(response.data)
      // setCurrentOffset(response.data?.historic_listings?.length < 5 ? response.data?.historic_listings?.length : 0)
    }
  }, [response.data, response.isFetching])


  const total = archiveListingsData?.total
  const hasArchiveListings = !!(total)
  // console.log(response.isFetching)
  return (
    <ArchiveListings
      mobileBrowser={mobileBrowser}
      isListing={isListing}
      isBuilding={isBuilding}
      isPrint={isPrint}
      pageFrom={pageFrom}
      isArchiveListingsPage={isArchiveListingsPage}
      archiveListingsData={archiveListingsData}
      isFetching={isFetchingArchiveListings}
      isFetchingMore={isFetchingMoreArchiveListings}
      enableLoadMore={enableLoadMore}
      showLinkToHistoryPage={showLinkToHistoryPage}
      enableFilterBar={enableFilterBar}
      total={total}
      priceHistoryAtText={priceHistoryAtText}
      propertyClass={propertyClass}
      hasArchiveListings={hasArchiveListings}
      loadArchiveListings={loadArchiveListings}
      suiteNumber={suiteNumber}
      buildingId={buildingId}
      addressId={addressId}
      perPage={perPage}
      offer={offer}
    />
  )
}

ArchiveListingsApiContainer.propTypes = {
  isListing: PropTypes.bool,
  isBuilding: PropTypes.bool,
  isPrint: PropTypes.bool,
  isArchiveListingsPage: PropTypes.bool,
  enableLoadMore: PropTypes.bool,
  showLinkToHistoryPage: PropTypes.bool,
  buildingId: PropTypes.number,
  addressId: PropTypes.number,
  suiteNumber: PropTypes.string,
  propertyClass: PropTypes.string,
  priceHistoryAtText: PropTypes.string,
  offer: PropTypes.string,
  pageFrom: PropTypes.string,
  enableFilterBar: PropTypes.bool,
  bedTypeNum: PropTypes.string,
}

export default ArchiveListingsApiContainer

